import { h } from "preact";

const Description = ({ description }) => {
  return description ? (
    <p style={{ fontSize: 14, color: "#5a626c", marginBottom: 8 }}>
      {description}
    </p>
  ) : null;
};

export default Description;
